import { FC } from 'react'
import styled from 'styled-components'
import { BaseButton } from '../buttons'

const InfoPopup = styled.div`
    display: none;
    position: absolute;
    //bottom: -10px;
    //left: 50%;
    //transform: translateX(-50%);
    left: 100%;
`

const ActionButton = styled(BaseButton)`
    margin-right: 8px;
    color: ${(p) => p.theme.colors.mediumGrey};
    position: relative;

    &:hover {
        color: ${(p) => p.theme.colors.primaryGreen};

        ${InfoPopup} {
            display: block;
        }
    }
`

interface Props {
    onClick: () => void
    description?: string
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
    iconSize?: number
}

export const Action: FC<Props> = ({
    icon: IconComponent,
    iconSize,
    description,
    onClick,
}) => {
    return (
        <ActionButton onClick={onClick}>
            <IconComponent
                style={{
                    width: iconSize ?? 32,
                    height: iconSize ?? 32,
                }}
            />
            {description && <InfoPopup>{description}</InfoPopup>}
        </ActionButton>
    )
}
